import axios from 'axios';

/**
 * Coalesces ProductUpdated broadcasts. A burst (import, stock take, a big sale)
 * used to mean one /api/p_details call per product per open tab, plus a full
 * reload for every one that failed - enough to hit the API rate limit (429).
 * Now ids are collected for a moment: a few are looked up one by one, more than
 * that and the page reloads its list once. Failures also share one reload.
 */
export function createProductUpdateBatcher({ apply, reloadAll, delay = 400, maxSingles = 5 }) {
    let ids = new Set();
    let flushTimer = null;
    let reloadTimer = null;

    const reloadSoon = () => {
        clearTimeout(reloadTimer);
        reloadTimer = setTimeout(reloadAll, delay);
    };

    const flush = () => {
        const batch = [...ids];
        ids = new Set();
        if (batch.length > maxSingles) {
            reloadSoon();
            return;
        }
        batch.forEach(productId => {
            axios.get('/api/p_details', { params: { product_id: productId }, _silent: true })
                .then(res => apply(res.data))
                .catch(reloadSoon);
        });
    };

    return {
        add(productId) {
            ids.add(productId);
            clearTimeout(flushTimer);
            flushTimer = setTimeout(flush, delay);
        },
        reloadSoon,
        cancel() {
            clearTimeout(flushTimer);
            clearTimeout(reloadTimer);
            ids = new Set();
        },
    };
}
